import { useTranslation } from 'react-i18next';

import './style.scss';

export const EmptyPosts = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="empty-posts">
      <div className="empty-posts-cover" />
      <span>{t('no_content')}</span>
    </div>
  );
};
